/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";
import { IoLogoWhatsapp } from "react-icons/io5";
import { FiCheck, FiSmartphone, FiRefreshCw } from "react-icons/fi";
import {
  useWhatsAppStatus,
  useWhatsAppSession,
} from "services/api/AppWeb_WhatsApp/useWhatsAppStatus";
import * as S from "../styles";

interface WhatsAppConnectProps {
  onStatusChange?: (connected: boolean) => void;
}

const WhatsAppConnect: React.FC<WhatsAppConnectProps> = ({
  onStatusChange,
}) => {
  const { data: statusData, refetch } = useWhatsAppStatus();
  const session = useWhatsAppSession();

  const [qr, setQr] = useState<string | null>(null);
  const [polling, setPolling] = useState(false);

  // status/v1 retorna { success: true, data: { conectado: false, status: "sem_sessao" } }
  const conectado = statusData?.data?.conectado === true;
  const verificando = !statusData;

  useEffect(() => {
    onStatusChange?.(conectado);
  }, [conectado, onStatusChange]);

  // Polling após gerar QR — checa status a cada 3s
  useEffect(() => {
    if (!polling) return undefined;
    const iv = setInterval(() => {
      refetch().then((r) => {
        if (r.data?.data?.conectado === true) {
          setQr(null);
          setPolling(false);
          toast.success("WhatsApp conectado!");
        }
      });
    }, 3000);
    return () => clearInterval(iv);
  }, [polling, refetch]);

  async function conectar() {
    try {
      // session/v1 retorna { success: true, data: { qrCode: "...", sessionId: "..." } }
      const response = await session.mutateAsync();
      const qrCode = response?.data?.qrCode;
      if (qrCode) {
        setQr(qrCode);
        setPolling(true);
        toast.success("QR Code gerado!");
      }
    } catch {
      // Erro já tratado pelo onError do hook
    }
  }

  return (
    <S.ConnectCard>
      <S.ConnectStatusBar connected={conectado}>
        <S.StatusDot connected={conectado} checking={verificando} />
        <div>
          <S.StatusTitle connected={conectado}>
            {verificando
              ? "Verificando..."
              : conectado
              ? "Conectado"
              : "Desconectado"}
          </S.StatusTitle>
          <S.StatusSubtitle>
            {conectado
              ? "WhatsApp pronto para uso"
              : "Escaneie o QR para conectar"}
          </S.StatusSubtitle>
        </div>
      </S.ConnectStatusBar>

      <S.ConnectBody>
        <S.ConnectIconWrapper connected={conectado}>
          {conectado ? <FiCheck size={36} /> : <IoLogoWhatsapp size={36} />}
        </S.ConnectIconWrapper>

        {qr && !conectado && (
          <S.QrContainer>
            <img src={qr} alt="QR Code" />
            <S.QrHint>
              Abra o WhatsApp &rarr; Dispositivos Vinculados &rarr; Vincular
              dispositivo
            </S.QrHint>
          </S.QrContainer>
        )}

        {!conectado && (
          <S.ConnectBtn
            onClick={conectar}
            disabled={session.isLoading || verificando}
          >
            {session.isLoading ? (
              <>
                <CircularProgress size={16} color="inherit" />
                Gerando QR...
              </>
            ) : qr ? (
              <>
                <FiRefreshCw size={16} /> Novo QR Code
              </>
            ) : (
              <>
                <FiSmartphone size={16} /> Gerar QR Code
              </>
            )}
          </S.ConnectBtn>
        )}

        {conectado && (
          <S.ConnectedInfo>
            Sessão ativa — mensagens sendo recebidas
          </S.ConnectedInfo>
        )}
      </S.ConnectBody>
    </S.ConnectCard>
  );
};

export default WhatsAppConnect;
